/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = require("core-js-pure/stable/instance/map");
